import React from "react";

import useCategoryToProductsList from "../../apiHooks/useCategoryToProductsList";
import IOTProductList from "../iot-product-list/iot-product-list.component";
import Card from "../../common/card/card.js";

import "./products-list.component.scss";

const ProductsList = () => {
  const { status, content: productsToApiList } = useCategoryToProductsList();

  return (
    <div className="product-list lg:block">
      <Card cardClass="list-card">
        <div className="py-6">
          <h3 className="-my-3 flow-root">
            <div
              className="flex w-full items-center justify-between  py-3 text-sm text-gray-400 hover:text-gray-500"
              aria-controls="filter-section-1"
              aria-expanded="false"
            ></div>
          </h3>

          <div className="pt-6" id="filter-section-1">
            <div>
              {/* {Object.keys(productsList).map((product) => (
                <div className="flex items-center filter">
                  <input
                    id="filter-category-0"
                    name="category[]"
                    value="new-arrivals"
                    type="checkbox"
                    onChange={() => onSelectApiProduct(productsList[product].key)}
                    className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                    checked={selectedApiProductsList.includes(productsList[product].key)}
                  />
                  <label
                    htmlFor="filter-category-0"
                    className="ml-3 text-sm"
                  >
                    {productsList[product].displayName}
                  </label>
                </div>
              ))} */}
              <IOTProductList productsList={Object.keys(productsToApiList)} />
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default ProductsList;
